import { connect } from 'react-redux';
import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import { CANCELLATION_GUARANTEE } from '../../products';
import NewSmallCardLayout from '../../common/components/small-card-layout/NewSmallCardLayout';
import { useProductData } from '../../common/hook/useProductData';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = CANCELLATION_GUARANTEE;
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  PostBooking: POSTBOOKING_CARD_LAYOUT
} = ProductCardLayoutType;
const sharedTexts = {
  readMoreContent: 'cancellationGuaranteeReadMoreModalContent',
  title: 'cancellationGuaranteeTitle',
  persuasionContent: 'cancellationGuaranteePersuasionContent'
};
const mainCardTranslations = {
  ...sharedTexts,
  additionalInformation: 'cancellationGuaranteeAdditionalInformation',
  abstractContent: 'cancellationGuaranteeAbstract',
  upSell: 'cancellationGuaranteeUpSellText'
};
const translations = {
  [MAIN_CARD_LAYOUT]: mainCardTranslations,
  [POSTBOOKING_CARD_LAYOUT]: mainCardTranslations,
  [SMALL_CARD_LAYOUT]: {
    ...sharedTexts,
    abstractContent: 'cancellationGuaranteeAbstractSmallCard',
    upSell: 'cancellationGuaranteeUpSellTextSmallCard'
  }
};
const CancellationGuarantee = _ref => {
  let {
    form,
    isSelected,
    order,
    productPosition,
    layoutType = MAIN_CARD_LAYOUT,
    className,
    sellSpecification
  } = _ref;
  const texts = translations[layoutType] || {};
  const {
    productData,
    rootElement
  } = useProductData({
    productId: PRODUCT_ID,
    order,
    productName: PRODUCT_NAME,
    productPosition,
    isSelected,
    form,
    sellSpecification,
    className,
    texts,
    layoutType
  });
  if (!productData) {
    return null;
  }
  switch (layoutType) {
    case SMALL_CARD_LAYOUT:
      return /*#__PURE__*/_jsx(NewSmallCardLayout, {
        productData: productData,
        ref: rootElement
      });
    case MAIN_CARD_LAYOUT:
    default:
      return /*#__PURE__*/_jsx(ProductLayout, {
        productData: productData,
        ref: rootElement
      });
  }
};
const mapStateToProps = (state, _ref2) => {
  let {
    form
  } = _ref2;
  return {
    isSelected: getSelected(CANCELLATION_GUARANTEE.name, form)(state)
  };
};
export default connect(mapStateToProps)(CancellationGuarantee);
//# sourceMappingURL=CancellationGuarantee.js.map